import { Chip as MuiChip, styled } from '@mui/material';

export const Chip = styled(MuiChip)`
  pointer-events: none;
`;
